export default {
      id: "icon-bed-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-bed",
      toString: function () {
        return this.url;
      }
    }